var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#00D27A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5V7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17V18.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.5C15.5 9.1717 15.4353 8.84661 15.3097 8.54329C15.1841 8.23998 14.9999 7.96438 14.7678 7.73223C14.5356 7.50009 14.26 7.31594 13.9567 7.1903C13.6534 7.06466 13.3283 7 13 7H10.75C10.087 7 9.45107 7.26339 8.98223 7.73223C8.51339 8.20107 8.25 8.83696 8.25 9.5C8.25 10.163 8.51339 10.7989 8.98223 11.2678C9.45107 11.7366 10.087 12 10.75 12H13.5C14.163 12 14.7989 12.2634 15.2678 12.7322C15.7366 13.2011 16 13.837 16 14.5C16 15.163 15.7366 15.7989 15.2678 16.2678C14.7989 16.7366 14.163 17 13.5 17H10.5C9.83696 17 9.20107 16.7366 8.73223 16.2678C8.26339 15.7989 8 15.163 8 14.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdSign);
export default __webpack_public_path__ + "static/media/usdSign.1e9e77c0ab6d8a9c9e7d0cf72be1f0d4.svg";
export { ForwardRef as ReactComponent };